module.exports = __webpack_public_path__ + "img/splash-image-4.05dee9ba.png";